module.exports = __webpack_public_path__ + "static/media/beans.786abce5.jpg";